import localizationKeys from "../../i18n/localizationKeys";


export const CONFIRMATION_MODAL_PROMPTS = {
  SAVE: {
    title: localizationKeys.DashboardLiveTrendConfirmationDialogPromptSaveTitle,
    message: localizationKeys.DashboardLiveTrendConfirmationDialogPromptSaveSubtitle,
    okText: localizationKeys.DashboardLiveTrendConfirmationDialogPromptSaveOkButton,
    cancelText: localizationKeys.DashboardLiveTrendConfirmationDialogPromptSaveCancelButton,
  },
  CANCEL: {
    title: localizationKeys.DashboardLiveTrendConfirmationDialogPromptCancelTitle,
    message: localizationKeys.DashboardLiveTrendConfirmationDialogPromptCancelSubtitle,
    okText: localizationKeys.DashboardLiveTrendConfirmationDialogPromptCancelOkButton,
    cancelText: localizationKeys.DashboardLiveTrendConfirmationDialogPromptCancelCancelButton,
  },
  DELETE: {
    title: localizationKeys.DashboardLiveTrendConfirmationDialogPromptDeleteTitle,
    message: localizationKeys.DashboardLiveTrendConfirmationDialogPromptDeleteSubtitle,
    okText: localizationKeys.DashboardLiveTrendConfirmationDialogPromptDeleteOkButton,
    cancelText: localizationKeys.CancelButtonText,
  },
};
